import { Environment } from '@rma/public/generic/util/environment';

// Production builds expect APP_ENVIRONMENT to be supplied at runtime by the
// container. This file replaces environment.ts in `-c production` so that no
// dev API URLs, dev LD client IDs, or dev identity secrets end up in the
// shipped bundle.
//
// The values below are chosen so the application builder's route-extraction
// worker (which evaluates server/index.ts during prerendering with no
// APP_ENVIRONMENT set) can construct URLs without throwing. They are NOT
// representative of any real environment — server/index.ts refuses to boot
// when this placeholder is used at runtime.
export const environment: Environment & { readonly __isProdPlaceholder: true } = {
  __isProdPlaceholder: true,
  type: 'develop',
  domain: 'placeholder.invalid',
  googleMapKey: '',
  countryCode: 'AU',
  tenantCode: 'global',
  launchDarklyClientId: '',
  recaptchaSiteKey: '',
  version: '',
  social: {
    facebookId: '',
    facebookUrl: '',
    twitterName: '',
    twitterUrl: '',
    linkedinUrl: '',
    instagramUrl: '',
  },
  identity: {
    client: '',
    secret: '',
    jwtEnvironment: '',
  },
  tracking: {
    googleAnalytics: {},
  },
  language: {
    // Non-empty locale so transloco's preload initializer can compute a URL;
    // non-empty url so the request resolves to a 404 (handled) rather than
    // hanging on a malformed empty path during build-time route extraction.
    locale: 'en-AU',
    url: 'https://placeholder.invalid',
  },
};
